<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .row
                .col-md-5.col-xs-12
                    .divisible-multiplier
                        span
                            template(v-if='params.numbers.length  ===  0')
                                |   {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')  }}
                            template(v-else='')
                                |   {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}
                    .form__field_columns.form__field_numbers
                        template(v-for='(number,  index)  in  numbers')
                            cs-checkbox.checkbox-for-numbers(
                                :checked="params.numbers && params.numbers.includes(number)",
                                @change="params.numbers = index === 0 ? [] : numbers.slice(0, index + 1)"
                            )
                                | {{ number }}
                    .form__field--column
                        template(v-for='(value,  key)  in  digitCapacity')
                            cs-checkbox(
                                :checked="params.digitCapacity.left && params.digitCapacity.left.includes(+key)",
                                @change="setKey('left', +key)"
                            )
                                | {{  value  }}
                .col-md-3.col-xs-12
                    .divisible-multiplier
                        span.column-name
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_operations')  }}
                    .form__field_operations
                        .form__field-body.multiplication-division
                            cs-checkbox(
                                v-model="params.operations.multiply"
                            )
                                |   {{  $i18n.t('trainer.trainer_gameFormSetting_operationMultiply')  }}
                        .form__field-body.multiplication-division
                            cs-checkbox(
                                v-model='params.operations.divide'
                            )
                                |   {{  $i18n.t('trainer.trainer_gameFormSetting_operationDivide')  }}
                    span.help.is-danger(v-show="errors.has('modes')")
                        |  {{  $i18n.t('trainer.trainer_gameFormErrors_chooseOperation')  }}
                .col-md-4.col-xs-12
                    .divisible-multiplier
                        span.column-name
                            template(v-if='params.numbers.length  ===  0')
                                |  {{  $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier')  }}
                            template(v-else)
                                |  {{  $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')  }}
                    .form__field--column
                        template(v-for='(value,  key)  in  digitCapacity')
                            cs-checkbox(
                                :checked='params.digitCapacity.right && params.digitCapacity.right.includes(+key)'
                                @change="setKey('right', +key)"
                                :disabled="isDisabled(key)"
                            )
                                |   {{  value  }}
                        cs-checkbox(
                            v-model='params.tabulatedValue'
                            :disabled="params.numbers.length === 0 "
                        )
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_tableValue')  }}
                    span.help.is-danger(v-show="errors.has('right')")
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_select')  }}
                        template(v-if='params.numbers.length  ===  0')
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier')  }}
                        template(v-else='')
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')  }}
            divider
            .buttons-container
                cs-button.button.is-outlined.is-info(type="button", @click='cancel' pattern="primary-outline", color="blue")
                    |  {{  $i18n.t('trainer.trainer_gameFormSetting_dontSave')  }}
                cs-button.button.is-info(type="button", @click='saveGame', color="blue")
                    |  {{  $i18n.t('trainer.trainer_gameFormSetting_saveGame')  }}

</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import TrainerGames from '../../../config/trainer';
    import {mapState} from 'vuex';

    export default {
        props: ['gameMode', 'slug', 'id', 'userId', 'homeworkId'],
        mixins: [GameFormMixin],
        data () {
            return {
                numbers: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                capacity: [1, 2, 3, 4, 5, 6, 7, 8],
                digitCapacity: {
                    1: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                    2: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                    3: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                    4: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                    5: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                    6: this.$i18n.t('common.common_gameSetting_digitCapacity6'),
                    7: this.$i18n.t('common.common_gameSetting_digitCapacity7'),
                    8: this.$i18n.t('common.common_gameSetting_digitCapacity8'),
                },
                params: null,
                games: TrainerGames.games
            }
        },
        mounted() {
            this.setInitParams(this.getKey(this.userId));
        },
        watch: {
            'params.digitCapacity.left': {
                handler (val) {
                    this.params.digitCapacity.right = this.params.digitCapacity.right.filter(item => item <= Math.max.apply(null, val))
                }
            },
            'params.numbers': {
                handler (val) {
                    val.length === 0 && (this.params.tabulatedValue = false)
                }
            }
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
            })
        },
        methods: {
            isDisabled (value) {
                return Math.max.apply(null, this.params.digitCapacity.left) < value
            },
            setKey(key, value) {
                if (value !== 1) {
                    this.params.digitCapacity[key] = [1, 2, 3, 4, 5, 6, 7, 8].slice(0, value)
                } else {
                    this.params.digitCapacity[key] = [];
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        max-width: 1020px;
        margin: 0 auto;
        box-sizing: border-box;
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__field_columns {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
    }

    .form__field_numbers {
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        @include media ($xl) {
            width: 250px;
        }
        @include media($xlg) {
            width: 280px;
        }
    }

    .form__field--column {
        flex-direction: column;
        @include stack-space($space-base);
        align-items: flex-start;
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field_operations {
        display: flex;
        @media screen and (max-width: 767px) {
            :first-child {
                flex-grow: 0;
                margin-right: 10px;
            }
        }
        @include media ($md){
            display: block;
        }
    }

    .col-md-4:first-child {
        @media screen and (min-width: 740px) {
            padding-right: 30px;
        }
        .form__field--column {
            @media screen and (min-width: 768px) and (max-width: 850px) {
                width: 180px;
            }
        }
    }

    .col-md-4:last-child {
        .form__field--column {
            @media screen and (min-width: 768px) and (max-width: 820px) {
                font-size: 14px;
            }
        }
    }

    .checkbox-for-numbers {
        margin-right: 15px;
        margin-bottom: $space-small !important;
    }

    .divisible-multiplier {
        margin: 10px 5px;
    }

    .buttons-container {
        display: flex;
        justify-content: center;
        margin: 20px;
        flex-direction: column;
        @include media($sm) {
            flex-direction: row;
        }
    }

    .button.is-info {
        height: 100% !important;
        font-size: $font-size-16;
        &:first-child {
            margin-bottom: 20px;
            @include media ($sm) {
                margin: 0 5px;
            }
        }
        @include media ($md) {
            font-size: $font-size-16;
            margin: 0 15px;
        }
    }
</style>
